import { AntdForm } from '@/common/components/AntdForm/index.tsx'
import { AntdFormRules } from '@/common/components/AntdForm/rules.tsx'
import React from 'react'
import { AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { SelectOption } from '@/common/types/components.def.ts'

type AntdFormDetailedFileListProps = {
  documentType: string
  employeeId: string
  labelOptions?: SelectOption[]
  itemLabel?: string
} & AntdFormItemProps

export const AntdFormDetailedFileList: React.FC<AntdFormDetailedFileListProps> = ({
  fieldProps,
  documentType,
  employeeId,
  itemLabel,
  labelOptions,
}) => {
  return (
    <AntdForm.List fieldProps={fieldProps} itemLabel={itemLabel || 'Record'}>
      <AntdForm.Section>
        <AntdForm.ComboBox
          fieldProps={{
            label: 'Label',
            name: 'label',
            rules: [AntdFormRules.required],
          }}
          options={labelOptions || []}
        />
        <AntdForm.SingleEmployeeDocumentUpload
          fieldProps={{
            label: 'File',
            name: 'file',
            rules: [AntdFormRules.required],
            span: 8,
          }}
          documentType={documentType}
          employeeId={employeeId}
        />
      </AntdForm.Section>
    </AntdForm.List>
  )
}